export const MarketplaceStatus = {
  Disabled: 'disabled',
  Requested: 'requested',
  Rejected: 'rejected',
  Enabled: 'enabled'
} as const

export type MarketplaceStatus =
  (typeof MarketplaceStatus)[keyof typeof MarketplaceStatus]

export const OnboardingStatus = {
  NeedCreatives: 'need_creatives',
  NeedSpots: 'need_spots',
  NeedCall: 'need_call',
  NeedCodes: 'need_codes',
  Onboarded: 'onboarded'
} as const

export type OnboardingStatus =
  (typeof OnboardingStatus)[keyof typeof OnboardingStatus]

export const ContactChannel = {
  Telegram: 'telegram',
  Email: 'email'
} as const

export type ContactChannel =
  (typeof ContactChannel)[keyof typeof ContactChannel]

export interface PaymentUnderReview {
  paymentSystem: string
  amount: number
}

export interface RawPaymentUnderReview {
  payment_system: string | null
  amount: number
  new_payment: boolean
}

export interface Account {
  id: string
  name: string
  referrerCode: number
  staff: boolean
  marketplaceStatus: MarketplaceStatus
  onboardingStatus: OnboardingStatus
  onboardingStep: number
  hadInitialTalk: boolean
  initialTalkRequested: boolean
  flatDealAdTypeIds: number[]
  flags: string[]
  balanceCents: number
  frozen: boolean
  allowedPayments: string
  termsAccepted: boolean
  showSystemMessage: boolean
  systemMessage: string
  agreementUrl: string
  withValidAgreement: boolean
  withValidContact: boolean
  agreementCreationAllowed: boolean
  paymentsUnderReview: RawPaymentUnderReview[]
  withWidget: boolean
  widgetData: string | null
}
